import { render, staticRenderFns } from "./setReadSubjectiveAnswer.vue?vue&type=template&id=32abaabc&scoped=true"
import script from "./setReadSubjectiveAnswer.vue?vue&type=script&lang=js"
export * from "./setReadSubjectiveAnswer.vue?vue&type=script&lang=js"
import style0 from "./setReadSubjectiveAnswer.vue?vue&type=style&index=0&id=32abaabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32abaabc",
  null
  
)

export default component.exports